interface LogoProps {
  className?: string;
  white?: boolean;
}

export function Logo({ className = "h-[50px] w-auto", white = false }: LogoProps) {
  return (
    <img
      src="/logos/leogroup.png"
      alt="LEO Group"
      className={`object-contain ${white ? "brightness-0 invert" : ""} ${className}`}
      draggable={false}
      onError={(e) => { e.currentTarget.style.visibility = "hidden"; }}
    />
  );
}
